"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _KYCSumSubLevelsComponent = _interopRequireDefault(require("./KYCSumSubLevelsComponent"));
var _kycJumioActions = require("../../redux/actions/kycJumioActions");
var _kycLevelsSelectors = require("../../redux/selectors/kycLevelsSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _kycLevelFormSelector = (0, _kycLevelsSelectors.kycLevelFormSelector)(state),
    kyc = _kycLevelFormSelector.kyc,
    alphaPointSessiontoken = _kycLevelFormSelector.alphaPointSessiontoken,
    alphaPointUserID = _kycLevelFormSelector.alphaPointUserID,
    userConfig = _kycLevelFormSelector.userConfig,
    userName = _kycLevelFormSelector.userName;
  var kycData = (0, _kycLevelsSelectors.kycVerificationLevelsSelector)(state);
  var verificationLevel = kycData.verificationLevel,
    levelIncreaseStatus = kycData.levelIncreaseStatus,
    kycConfig = kycData.kycConfig;
  var highlightStyle = kycConfig.highlightStyle;
  return {
    kyc: kyc,
    userName: userName,
    kycConfig: kycConfig,
    userConfig: userConfig,
    highlightStyle: highlightStyle,
    alphaPointUserID: alphaPointUserID,
    verificationLevel: verificationLevel,
    levelIncreaseStatus: levelIncreaseStatus,
    alphaPointSessiontoken: alphaPointSessiontoken,
    userId: state.user.userInfo.UserId
  };
};
var mapDispatchToProps = {
  validateUserRegistration: _kycJumioActions.validateUserRegistration
};
var KYCSumSubLevelsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_KYCSumSubLevelsComponent["default"]);
var _default = exports["default"] = KYCSumSubLevelsContainer;